// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","443":"about","809":"account"}[chunkId] + "." + {"18":"42c08a84","443":"bc67c0e4","809":"2b8674b9"}[chunkId] + ".js";
};